/**
 * 下拉
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import Select from 'react-select-okjp';
import CreatableSelect from 'react-select-okjp/lib/Creatable';

import 'react-datepicker-okjp/src/react-datepicker.css';
import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemSelect extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
    };
    this.select = {};
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
    this.cleanValue(nextProps.dataSource);
  }

  /**
   * 下拉/单选框值变化监听
   * @param newValue 新的值所在的对象
   */
  onSelectChange = (newValue) => {
    const { key, onChange, errorData, formType, extend } =
      this.props.dataSource;
    const val = newValue || { value: '', label: '' };
    const errorMsg = this.getErrorMsg(val, errorData);
    const allow = errorMsg.length === 0;
    this.setState({
      value: val.value,
      errorMsg,
      dataError: errorMsg && errorMsg.length !== 0,
    });
    onChange && onChange(key, formType, val, allow, extend);
  };

  onFocus = () => {
    // make the select input text editable
    this.select.select.state.inputValue =
      this.props.dataSource.value === '' ? '' : this.state.value;
  };

  // handle manually inputted value in editable mode
  onBlur = () => {
    const { list, inputValue } = this.props.dataSource;
    if (inputValue) {
      this.select.select.state.inputValue = inputValue.value;
      // if selected value is not in list, add it.
      if (
        list &&
        list.length > 0 &&
        !list.some((v) => {
          return v.value === inputValue.value && v.label === inputValue.value;
        })
      ) {
        list.unshift(inputValue);
        this.onSelectChange(inputValue);
      }
    }
  };

  promptTextCreator = (label) => {
    this.props.dataSource.inputValue = { value: label, label };
    return `${this.props.dataSource.inputAttr.textCreator}"${label}"`;
  };

  /**
   * 渲染下拉类型
   * @returns {*}
   */
  renderFormLineSelect() {
    const { errorMsg, value } = this.state;
    const { list, inputAttr, bottomArea, editable } = this.props.dataSource;
    if (editable) {
      const postChanged = this.props.dataSource.value !== value;
      // if selected value is not in list, add it.
      if (
        !postChanged &&
        value !== '' &&
        list &&
        list.length > 0 &&
        !list.some((v) => {
          return v.value === value && v.label === value;
        })
      ) {
        list.unshift({ value, label: value });
      }
    }
    return (
      <div className="form-input-box">
        <span className="form-select">
          {!editable && (
            <Select
              {...inputAttr}
              options={list}
              name="form-field-name"
              className="select-type"
              value={value}
              clearable={false}
              onChange={this.onSelectChange}
            />
          )}
          {editable && (
            <CreatableSelect
              {...inputAttr}
              ref={(ref) => {
                this.select = ref;
              }}
              options={list}
              name="form-field-name"
              className="select-type"
              value={value}
              clearable={false}
              onChange={this.onSelectChange}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              promptTextCreator={this.promptTextCreator}
            />
          )}
        </span>
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  // 渲染下部提示
  renderTips(tips, isSpecial) {
    if (!tips || tips.length === 0) {
      return null;
    }
    return (
      <div className="tips-box">
        {tips.map((item, index) => {
          return (
            <div
              key={`tips${isSpecial ? 'Special' : ''}${index}`}
              className={`tips-item ${isSpecial ? 'especial' : ''}`}
            >
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    const { bottomTips } = dataSource;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineSelect()}
        {this.renderTips(bottomTips)}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemSelect.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.SELECT,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
